module.exports = __webpack_public_path__ + "static/media/Supplement Facts.0866ee45.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Supplement Facts.png
// module id = 1188
// module chunks = 0